import { array, boolean, number, object, SchemaOf, string } from 'yup';

import { metadataValidation } from '@/react/portainer/environments/common/MetadataFieldset/validation';

import { D2KInstance, FormValues } from './types';

export const D2K_NAMESPACE_PREFIX = 'd2k-';

// d2k-<name> must be a valid namespace name: a DNS-1123 label of at most 63
// characters, so <name> has at most 59.
const NAME_MAX_LENGTH = 63 - D2K_NAMESPACE_PREFIX.length;
const NAME_REGEX = /^[a-z0-9-]*[a-z0-9]$/;

export function validation(): SchemaOf<FormValues> {
  return object({
    parentEnvironmentId: number()
      .default(0)
      .min(1, 'Select the Kubernetes environment to run D2K in'),
    instances: array()
      .of(instanceValidation())
      .min(1, 'Add at least one D2K instance')
      .test(
        'unique-names',
        'Each D2K instance needs its own name',
        (instances) => isUnique(instances?.map((i) => i?.name))
      ),
    swarmMode: boolean().default(false),
    meta: metadataValidation(),
  });
}

function instanceValidation(): SchemaOf<D2KInstance> {
  return object({
    name: string()
      .default('')
      .required('Name is required')
      .max(
        NAME_MAX_LENGTH,
        `Name must be ${NAME_MAX_LENGTH} characters or less`
      )
      .matches(
        NAME_REGEX,
        "Name must consist of lower case alphanumeric characters or '-', and end with an alphanumeric character (e.g. 'team-a')"
      ),
    auto: boolean().default(false),
  });
}

function isUnique(values: Array<string | null | undefined> = []) {
  const present = values.filter((v) => !!v);
  return new Set(present).size === present.length;
}
